module.exports = __webpack_public_path__ + "static/media/1009880.0be04ec3.jpg";